/**
 * « Cette personne a une photo » : élève ou membre du personnel.
 *
 * Même règle que le serveur (A_PHOTO_SQL, backend2/routes/eleves.routes.js) :
 * un chemin non vide. `TRIM` compte : une chaîne vide ou faite d'espaces n'est
 * pas une photo. Le filtre « Sans photo » des listes et le chiffre du panneau
 * des alertes s'appuient sur cette seule définition, pour ne jamais diverger.
 *
 * Seule la valeur en base est jugée : un fichier disparu du serveur n'est pas
 * détecté ici (la fiche de l'employé le vérifie à l'affichage).
 */
export const aUnePhoto = (personne) =>
  typeof personne?.photo_url === 'string' && personne.photo_url.trim() !== '';

/** Le paramètre d'adresse du lien direct : `?photo=sans`. */
export const PARAM_PHOTO = 'photo';
export const VALEUR_SANS_PHOTO = 'sans';
